import { jsx as f, Fragment as N } from "react/jsx-runtime";
import c, { createContext as V, useCallback as U, useMemo as T, useContext as _, forwardRef as b, useId as W } from "react";
import { S as H } from "./index-B_6_jmOO.js";
import { O as G, $ as g } from "./utils-CTvPli9r.js";
import "./expandable-chat-hsF4FM9n.js";
import "./multiselect.js";
import "react-router-dom";
import "./toast-BRKBR_c0.js";
import "./alert.js";
import "./avatar.js";
import "./breadcrumb.js";
import "./button.js";
import "./calendar-C-HUqdjN.js";
import "./card.js";
import "./checkbox.js";
import "./use-theme-xHxAHy0N-C40aLO4N.js";
import "./popover.js";
import "./command-ClHioAv1.js";
import "./dialog.js";
import "./dropdown-menu.js";
import "./hover-card.js";
import "./input.js";
import { Label as K } from "./label.js";
import "./loading-button.js";
import "./tooltip.js";
import "./select.js";
import "./sheet.js";
import "./slider.js";
import "./switch.js";
import "./table.js";
import "./tabs.js";
import "./textarea.js";
import "./toggle-BswawoKY.js";
const A = V({
  m: () => {
  }
});
var q = (e) => e.type === "checkbox", z = (e) => e instanceof Date, w = (e) => e == null;
const J = (e) => typeof e == "object";
var F = (e) => !w(e) && !Array.isArray(e) && J(e) && !z(e), Q = (e) => F(e) && e.target ? q(e.target) ? e.target.checked : e.target.value : e, X = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, Y = (e, r) => e.has(X(r)), Z = (e) => {
  const r = e.constructor && e.constructor.prototype;
  return F(r) && r.hasOwnProperty("isPrototypeOf");
}, ee = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function S(e) {
  let r;
  const t = Array.isArray(e);
  if (e instanceof Date)
    r = new Date(e);
  else if (e instanceof Set)
    r = new Set(e);
  else if (!(ee && (e instanceof Blob || e instanceof FileList)) && (t || F(e)))
    if (r = t ? [] : {}, !t && !Z(e))
      r = e;
    else
      for (const o in e)
        e.hasOwnProperty(o) && (r[o] = S(e[o]));
  else
    return e;
  return r;
}
var j = (e) => Array.isArray(e) ? e.filter(Boolean) : [], C = (e) => e === void 0, d = (e, r, t) => {
  if (!r || !F(e))
    return t;
  const o = j(r.split(/[,[\].]+?/)).reduce((s, n) => w(s) ? s : s[n], e);
  return C(o) || o === e ? C(e[r]) ? t : e[r] : o;
}, I = (e) => typeof e == "boolean", te = (e) => /^\w*$/.test(e), re = (e) => j(e.replace(/["|']|\]/g, "").split(/\.|\[/)), O = (e, r, t) => {
  let o = -1;
  const s = te(r) ? [r] : re(r), n = s.length, a = n - 1;
  for (; ++o < n; ) {
    const u = s[o];
    let i = t;
    if (o !== a) {
      const m = e[u];
      i = F(m) || Array.isArray(m) ? m : isNaN(+s[o + 1]) ? {} : [];
    }
    if (u === "__proto__")
      return;
    e[u] = i, e = e[u];
  }
  return e;
};
const P = {
  BLUR: "blur",
  CHANGE: "change"
}, k = {
  all: "all"
}, D = c.createContext(null), h = () => c.useContext(D), E = (e) => {
  const { children: r, ...t } = e;
  return c.createElement(D.Provider, { value: t }, r);
};
var se = (e, r, t, o = !0) => {
  const s = {
    defaultValues: r._defaultValues
  };
  for (const n in e)
    Object.defineProperty(s, n, {
      get: () => {
        const a = n;
        return r._proxyFormState[a] !== k.all && (r._proxyFormState[a] = !o || k.all), t && (t[a] = !0), e[a];
      }
    });
  return s;
}, oe = (e) => F(e) && !Object.keys(e).length, ne = (e, r, t, o) => {
  t(e);
  const { name: s, ...n } = e;
  return oe(n) || Object.keys(n).length >= Object.keys(r).length || Object.keys(n).find((a) => r[a] === !0);
}, ie = (e) => Array.isArray(e) ? e : [e], R = (e, r, t) => !e || !r || e === r || ie(e).some((o) => o && (t ? o === r : o.startsWith(r) || r.startsWith(o)));
function M(e) {
  const r = c.useRef(e);
  r.current = e, c.useEffect(() => {
    const t = !e.disabled && r.current.subject && r.current.subject.subscribe({
      next: r.current.next
    });
    return () => {
      t && t.unsubscribe();
    };
  }, [e.disabled]);
}
function ae(e) {
  const r = h(), { control: t = r.control, disabled: o, name: s, exact: n } = e || {}, [a, u] = c.useState(t._formState), i = c.useRef(!0), m = c.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), l = c.useRef(s);
  return l.current = s, M({
    disabled: o,
    next: (p) => i.current && R(l.current, p.name, n) && ne(p, m.current, t._updateFormState) && u({
      ...t._formState,
      ...p
    }),
    subject: t._subjects.state
  }), c.useEffect(() => (i.current = !0, m.current.isValid && t._updateValid(!0), () => {
    i.current = !1;
  }), [t]), se(a, t, m.current, !1);
}
var le = (e) => typeof e == "string", ce = (e, r, t, o, s) => le(e) ? d(t, e, s) : Array.isArray(e) ? e.map((n) => d(t, n)) : t;
function ue(e) {
  const r = h(), { control: t = r.control, name: o, defaultValue: s, disabled: n, exact: a } = e || {}, u = c.useRef(o);
  u.current = o, M({
    disabled: n,
    subject: t._subjects.values,
    next: (l) => {
      R(u.current, l.name, a) && m(S(ce(u.current, t._names, l.values || t._formValues, !1, s)));
    }
  });
  const [i, m] = c.useState(t._getWatch(o, s));
  return c.useEffect(() => t._removeUnmounted()), i;
}
function de(e) {
  const r = h(), { name: t, disabled: o, control: s = r.control, shouldUnregister: n } = e, a = Y(s._names.array, t), u = ue({
    control: s,
    name: t,
    defaultValue: d(s._formValues, t, d(s._defaultValues, t, e.defaultValue)),
    exact: !0
  }), i = ae({
    control: s,
    name: t,
    exact: !0
  }), m = c.useRef(s.register(t, {
    ...e.rules,
    value: u,
    ...I(e.disabled) ? { disabled: e.disabled } : {}
  }));
  return c.useEffect(() => {
    const l = s._options.shouldUnregister || n, p = (y, L) => {
      const x = d(s._fields, y);
      x && x._f && (x._f.mount = L);
    };
    if (p(t, !0), l) {
      const y = S(d(s._options.defaultValues, t));
      O(s._defaultValues, t, y), C(d(s._formValues, t)) && O(s._formValues, t, y);
    }
    return () => {
      (a ? l && !s._state.action : l) ? s.unregister(t) : p(t, !1);
    };
  }, [t, s, a, n]), c.useEffect(() => {
    d(s._fields, t) && s._updateDisabledField({
      disabled: o,
      fields: s._fields,
      name: t,
      value: d(s._fields, t)._f.value
    });
  }, [o, t, s]), {
    field: {
      name: t,
      value: u,
      ...I(o) || i.disabled ? { disabled: i.disabled || o } : {},
      onChange: c.useCallback((l) => m.current.onChange({
        target: {
          value: Q(l),
          name: t
        },
        type: P.CHANGE
      }), [t]),
      onBlur: c.useCallback(() => m.current.onBlur({
        target: {
          value: d(s._formValues, t),
          name: t
        },
        type: P.BLUR
      }), [t, s]),
      ref: c.useCallback((l) => {
        const p = d(s._fields, t);
        p && l && (p._f.ref = {
          focus: () => l.focus(),
          select: () => l.select(),
          setCustomValidity: (y) => l.setCustomValidity(y),
          reportValidity: () => l.reportValidity()
        });
      }, [s._fields, t])
    },
    formState: i,
    fieldState: Object.defineProperties({}, {
      invalid: {
        enumerable: !0,
        get: () => !!d(i.errors, t)
      },
      isDirty: {
        enumerable: !0,
        get: () => !!d(i.dirtyFields, t)
      },
      isTouched: {
        enumerable: !0,
        get: () => !!d(i.touchedFields, t)
      },
      isValidating: {
        enumerable: !0,
        get: () => !!d(i.validatingFields, t)
      },
      error: {
        enumerable: !0,
        get: () => d(i.errors, t)
      }
    })
  };
}
const me = (e) => e.render(de(e)), fe = ({
  children: e,
  name: r,
  messages: t,
  apiError: o,
  ...s
}) => {
  const n = U(
    (u, i) => G(t, r, u, i),
    [t, r]
  ), a = T(() => ({ m: n, apiError: o }), [o, n]);
  return /* @__PURE__ */ f(A.Provider, { value: a, children: /* @__PURE__ */ f(E, { ...s, children: e }) });
};
fe.displayName = "ApiForm";
const $ = V({}), B = V({}), v = () => {
  const e = _($), r = _(B), { getFieldState: t, formState: o } = h(), s = t(e.name, o);
  if (!e)
    throw new Error("useFormField should be used within <FormField>");
  const { id: n } = r;
  return {
    id: n,
    name: e.name,
    formItemId: `${n}-form-item`,
    formDescriptionId: `${n}-form-item-description`,
    formMessageId: `${n}-form-item-message`,
    ...s
  };
}, Ze = E, et = ({
  ...e
}) => (
  // eslint-disable-next-line react/jsx-no-constructed-context-values
  /* @__PURE__ */ f($.Provider, { value: { name: e.name }, children: /* @__PURE__ */ f(me, { ...e }) })
), pe = b(
  ({ className: e, ...r }, t) => {
    const o = W();
    return (
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      /* @__PURE__ */ f(B.Provider, { value: { id: o }, children: /* @__PURE__ */ f("div", { ref: t, className: g("space-y-0.5", e), ...r }) })
    );
  }
);
pe.displayName = "FormItem";
const ye = b(({ className: e, ...r }, t) => {
  const { error: o, formItemId: s } = v();
  return /* @__PURE__ */ f(K, { ref: t, className: g(o && "text-destructive", e), htmlFor: s, ...r });
});
ye.displayName = "FormLabel";
const be = b(
  ({ ...e }, r) => {
    const { error: t, formItemId: o, formDescriptionId: s, formMessageId: n } = v();
    return /* @__PURE__ */ f(
      H,
      {
        ref: r,
        id: o,
        "aria-describedby": t ? `${s} ${n}` : `${s}`,
        "aria-invalid": !!t,
        ...e
      }
    );
  }
);
be.displayName = "FormControl";
const Fe = b(
  ({ className: e, ...r }, t) => {
    const { formDescriptionId: o } = v();
    return /* @__PURE__ */ f(
      "p",
      {
        ref: t,
        id: o,
        className: g("text-[0.8rem] text-muted-foreground", e),
        ...r
      }
    );
  }
);
Fe.displayName = "FormDescription";
const ge = b(
  ({ className: e, children: r, ...t }, o) => {
    var l, p;
    const { error: s, name: n, formMessageId: a } = v(), { m: u, apiError: i } = _(A), m = r || u(((p = (l = i == null ? void 0 : i.data) == null ? void 0 : l[n]) == null ? void 0 : p.type) ?? "", n) || u((s == null ? void 0 : s.type) ?? "", n);
    return /* @__PURE__ */ f(
      "p",
      {
        ref: o,
        id: a,
        className: g("text-[0.8rem] font-medium text-destructive", e),
        ...t,
        children: m ?? /* @__PURE__ */ f(N, { children: " " })
      }
    );
  }
);
ge.displayName = "FieldMessage";
const _e = b(
  ({ className: e, children: r, ...t }, o) => {
    const { m: s, apiError: n } = _(A), a = r || s((n == null ? void 0 : n.code) ?? "");
    return /* @__PURE__ */ f("p", { ref: o, className: g("text-[0.8rem] font-medium text-destructive", e), ...t, children: a ?? /* @__PURE__ */ f(N, { children: " " }) });
  }
);
_e.displayName = "FormMessage";
export {
  A,
  Ze as F,
  fe as a,
  pe as b,
  ye as c,
  be as d,
  Fe as e,
  ge as f,
  _e as g,
  et as h,
  $ as i,
  B as j,
  v as u
};
//# sourceMappingURL=form-Cpps2zk4.js.map
